import { DatabaseRecord } from "../repos/table.repo";

export interface DepartmentModel extends DatabaseRecord {
    name: string;
    code: string;
    waterFactoryId: string;
    information?: string;
}

export class DepartmentModelFactory {
    static getEmpty(): DepartmentModel {
        return {
            id: "",
            name: "",
            code: "",
            waterFactoryId: "",
            information: "",
        }
    }
}